module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', [(!_vm.$store.state.isWx) ? _c('router-link', {
    staticClass: "iconfont icon-shezhi",
    attrs: {
      "to": "userCenter/setUp",
      "tag": "i"
    }
  }) : _vm._e(), _vm._v(" "), _c('head-pic-file'), _vm._v(" "), _c('span', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.userInfo.nickname))]), _vm._v(" "), (_vm.userInfo.mobileNumber) ? _c('span', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.userInfo.mobileNumber.replace(/^(\d{3})\d{4}/g, '$1****')))]) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0539bf86"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserCenter/Header.vue
// module id = 509
// module chunks = 0